module.exports = __webpack_public_path__ + "img/athlete-soccer-background-right.8ef46e07.svg";